/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sandboxes_Unavailabledescription1Inputs */

const id_sandboxes_unavailabledescription1 = /** @type {(inputs: Sandboxes_Unavailabledescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hub produk tidak dapat dimuat.`)
};

const ms_sandboxes_unavailabledescription1 = /** @type {(inputs: Sandboxes_Unavailabledescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hab produk tidak dapat dimuatkan.`)
};

const da_sandboxes_unavailabledescription1 = /** @type {(inputs: Sandboxes_Unavailabledescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Produkt-hub'en kunne ikke indlæses.`)
};

const de_sandboxes_unavailabledescription1 = /** @type {(inputs: Sandboxes_Unavailabledescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Der Produkt-Hub konnte nicht geladen werden.`)
};

const en_us2_sandboxes_unavailabledescription1 = /** @type {(inputs: Sandboxes_Unavailabledescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The product hub could not be loaded.`)
};

const es_es2_sandboxes_unavailabledescription1 = /** @type {(inputs: Sandboxes_Unavailabledescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se pudo cargar el hub del producto.`)
};

const es_mx2_sandboxes_unavailabledescription1 = /** @type {(inputs: Sandboxes_Unavailabledescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se pudo cargar el hub del producto.`)
};

const fil_sandboxes_unavailabledescription1 = /** @type {(inputs: Sandboxes_Unavailabledescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hindi ma-load ang product hub.`)
};

const fr_sandboxes_unavailabledescription1 = /** @type {(inputs: Sandboxes_Unavailabledescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le hub produit n'a pas pu être chargé.`)
};

const it_sandboxes_unavailabledescription1 = /** @type {(inputs: Sandboxes_Unavailabledescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L'hub del prodotto non può essere caricato.`)
};

const hu_sandboxes_unavailabledescription1 = /** @type {(inputs: Sandboxes_Unavailabledescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A termékközpontot nem lehet betölteni.`)
};

const nl_sandboxes_unavailabledescription1 = /** @type {(inputs: Sandboxes_Unavailabledescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De producthub kon niet worden geladen.`)
};

const no_sandboxes_unavailabledescription1 = /** @type {(inputs: Sandboxes_Unavailabledescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Produkthuben kunne ikke lastes.`)
};

const pl_sandboxes_unavailabledescription1 = /** @type {(inputs: Sandboxes_Unavailabledescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nie można załadować centrum produktu.`)
};

const pt_br2_sandboxes_unavailabledescription1 = /** @type {(inputs: Sandboxes_Unavailabledescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não foi possível carregar o hub do produto.`)
};

const pt_sandboxes_unavailabledescription1 = /** @type {(inputs: Sandboxes_Unavailabledescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O centro do produto não pôde ser carregado.`)
};

const ro_sandboxes_unavailabledescription1 = /** @type {(inputs: Sandboxes_Unavailabledescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hub-ul produsului nu a putut fi încărcat.`)
};

const fi_sandboxes_unavailabledescription1 = /** @type {(inputs: Sandboxes_Unavailabledescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tuotehubia ei voitu ladata.`)
};

const sv_sandboxes_unavailabledescription1 = /** @type {(inputs: Sandboxes_Unavailabledescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Produktnavet kunde inte laddas.`)
};

const vi_sandboxes_unavailabledescription1 = /** @type {(inputs: Sandboxes_Unavailabledescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không thể tải trung tâm sản phẩm.`)
};

const tr_sandboxes_unavailabledescription1 = /** @type {(inputs: Sandboxes_Unavailabledescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ürün merkezi yüklenemedi.`)
};

const cs_sandboxes_unavailabledescription1 = /** @type {(inputs: Sandboxes_Unavailabledescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Centrum produktu nelze načíst.`)
};

const bg_sandboxes_unavailabledescription1 = /** @type {(inputs: Sandboxes_Unavailabledescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Центърът на продукта не можа да се зареди.`)
};

const ru_sandboxes_unavailabledescription1 = /** @type {(inputs: Sandboxes_Unavailabledescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Не удалось загрузить центр продукта.`)
};

const uk_sandboxes_unavailabledescription1 = /** @type {(inputs: Sandboxes_Unavailabledescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Не вдалося завантажити продукт.`)
};

const ar_sandboxes_unavailabledescription1 = /** @type {(inputs: Sandboxes_Unavailabledescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تعذر تحميل مركز المنتج.`)
};

const hi_sandboxes_unavailabledescription1 = /** @type {(inputs: Sandboxes_Unavailabledescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`उत्पाद हब लोड नहीं किया जा सका।`)
};

const th_sandboxes_unavailabledescription1 = /** @type {(inputs: Sandboxes_Unavailabledescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ไม่สามารถโหลดฮับผลิตภัณฑ์ได้`)
};

const ja_sandboxes_unavailabledescription1 = /** @type {(inputs: Sandboxes_Unavailabledescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プロダクトハブを読み込めませんでした。`)
};

const zh_cn2_sandboxes_unavailabledescription1 = /** @type {(inputs: Sandboxes_Unavailabledescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`无法加载产品中心。`)
};

const zh_hant1_sandboxes_unavailabledescription1 = /** @type {(inputs: Sandboxes_Unavailabledescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`無法載入產品中心。`)
};

const ko_sandboxes_unavailabledescription1 = /** @type {(inputs: Sandboxes_Unavailabledescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`제품 허브를 불러올 수 없습니다.`)
};

/**
* | output |
* | --- |
* | "The product hub could not be loaded." |
*
* @param {Sandboxes_Unavailabledescription1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const sandboxes_unavailabledescription1 = /** @type {((inputs?: Sandboxes_Unavailabledescription1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sandboxes_Unavailabledescription1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_sandboxes_unavailabledescription1(inputs)
	if (locale === "ms") return ms_sandboxes_unavailabledescription1(inputs)
	if (locale === "da") return da_sandboxes_unavailabledescription1(inputs)
	if (locale === "de") return de_sandboxes_unavailabledescription1(inputs)
	if (locale === "en-US") return en_us2_sandboxes_unavailabledescription1(inputs)
	if (locale === "es-ES") return es_es2_sandboxes_unavailabledescription1(inputs)
	if (locale === "es-MX") return es_mx2_sandboxes_unavailabledescription1(inputs)
	if (locale === "fil") return fil_sandboxes_unavailabledescription1(inputs)
	if (locale === "fr") return fr_sandboxes_unavailabledescription1(inputs)
	if (locale === "it") return it_sandboxes_unavailabledescription1(inputs)
	if (locale === "hu") return hu_sandboxes_unavailabledescription1(inputs)
	if (locale === "nl") return nl_sandboxes_unavailabledescription1(inputs)
	if (locale === "no") return no_sandboxes_unavailabledescription1(inputs)
	if (locale === "pl") return pl_sandboxes_unavailabledescription1(inputs)
	if (locale === "pt-BR") return pt_br2_sandboxes_unavailabledescription1(inputs)
	if (locale === "pt") return pt_sandboxes_unavailabledescription1(inputs)
	if (locale === "ro") return ro_sandboxes_unavailabledescription1(inputs)
	if (locale === "fi") return fi_sandboxes_unavailabledescription1(inputs)
	if (locale === "sv") return sv_sandboxes_unavailabledescription1(inputs)
	if (locale === "vi") return vi_sandboxes_unavailabledescription1(inputs)
	if (locale === "tr") return tr_sandboxes_unavailabledescription1(inputs)
	if (locale === "cs") return cs_sandboxes_unavailabledescription1(inputs)
	if (locale === "bg") return bg_sandboxes_unavailabledescription1(inputs)
	if (locale === "ru") return ru_sandboxes_unavailabledescription1(inputs)
	if (locale === "uk") return uk_sandboxes_unavailabledescription1(inputs)
	if (locale === "ar") return ar_sandboxes_unavailabledescription1(inputs)
	if (locale === "hi") return hi_sandboxes_unavailabledescription1(inputs)
	if (locale === "th") return th_sandboxes_unavailabledescription1(inputs)
	if (locale === "ja") return ja_sandboxes_unavailabledescription1(inputs)
	if (locale === "zh-CN") return zh_cn2_sandboxes_unavailabledescription1(inputs)
	if (locale === "zh-Hant") return zh_hant1_sandboxes_unavailabledescription1(inputs)
	return ko_sandboxes_unavailabledescription1(inputs)
});
export { sandboxes_unavailabledescription1 as "sandboxes.unavailableDescription" }